<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" style="background-color: white;" to="/">
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        src="img/avatars/logo2.png"
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        src="img/avatars/logo2.png"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import Vue from "vue";
import nav from './_nav'
import * as icons from '@coreui/icons';

export default {
  name: 'TheSidebar',
  inject: ['icons'],
  nav,
    data: function() {
    return {
     str:null
    };
  },
  created() {

    this.permission()
  },
  methods: {    
    permission() {
      this.ParserLimit();

      // this.$options.nav = Vue.prototype.GLOBAL.sysType == 'SCM' ? scm : this.ParserLimit(null);
      /// this.$options.nav = [JSON.parse(localStorage.getItem('limit'))];
      // admin;
      // console.log("nav",this.$options.nav)
      // cil-laptop cil-laptop
      // this.$options.nav=admin;


    },

    ParserLimit() {
       var children = [];
       children.push({
        _name: 'CSidebarNavItem',
        name: '主控版',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      })

      var production = localStorage.getItem('production');
      if (production != null && production != "") {

        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['生產作業']
        });        
        if (production.indexOf('10') >= 0 || production.indexOf('11') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '生產排程行事曆',
            to: '/production/calendar',
            icon: { content: icons.cilCalendarCheck }
          });
        }
        if (production.indexOf('20') >= 0 || production.indexOf('21') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '配方表管理',
            to: '/production/recipe',
            icon: { content: icons.cilBeaker }
          });
        }
        if (production.indexOf('30') >= 0 || production.indexOf('31') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '庫存管理',
            to: '/production/stock',
            icon: { content: [
              '512 512',
              `
              <path d="M443.733,375.467h-39.006c-4.719,0-8.533,3.814-8.533,8.533c0,4.719,3.814,8.533,8.533,8.533h39.006c4.71,0,8.533-3.814,8.533-8.533C452.267,379.281,448.444,375.467,443.733,375.467z"/>
              <path d="M443.734,341.333h-58.513c-4.71,0-8.533,3.814-8.533,8.533s3.823,8.533,8.533,8.533h58.513c4.71,0,8.533-3.814,8.533-8.533S448.445,341.333,443.734,341.333z"/>
              <path d="M503.467,409.6h-17.289c5.419-7.151,8.755-15.957,8.755-25.6V51.2c0-23.526-19.14-42.667-42.667-42.667h-102.4c0-4.719-3.823-8.533-8.533-8.533h-102.4c-4.71,0-8.533,3.814-8.533,8.533H128c-23.526,0-42.667,19.14-42.667,42.667v102.4h-25.6
                c-23.526,0-42.667,19.14-42.667,42.667V384c0,9.643,3.337,18.449,8.755,25.6H8.533c-4.71,0-8.533,3.814-8.533,8.533v51.2
                c0,4.719,3.823,8.533,8.533,8.533h8.533v25.6c0,4.719,3.823,8.533,8.533,8.533h68.267c4.71,0,8.533-3.814,8.533-8.533v-25.6
                h110.933v25.6c0,4.719,3.823,8.533,8.533,8.533h68.267c4.71,0,8.533-3.814,8.533-8.533v-25.6H409.6v25.6
                c0,4.719,3.823,8.533,8.533,8.533H486.4c4.71,0,8.533-3.814,8.533-8.533v-25.6h8.533c4.71,0,8.533-3.814,8.533-8.533v-51.2
                C512,413.414,508.177,409.6,503.467,409.6z M324.267,384c0,14.114-11.486,25.6-25.6,25.6H59.733c-14.114,0-25.6-11.486-25.6-25.6
                V196.267c0-14.114,11.486-25.6,25.6-25.6h34.133H128v68.267c0,3.285,1.877,6.263,4.838,7.689c2.953,1.425,6.46,1.024,9.028-1.024
                l37.333-29.875l37.333,29.875c0.717,0.572,1.519,0.981,2.347,1.297c0.265,0.094,0.529,0.137,0.802,0.205
                c0.589,0.154,1.169,0.273,1.775,0.299c0.137,0.008,0.273,0.068,0.41,0.068s0.265-0.085,0.393-0.094
                c1.126-0.051,2.253-0.247,3.302-0.751c2.961-1.425,4.838-4.403,4.838-7.689v-68.267h68.267c14.114,0,25.6,11.486,25.6,25.6V384z
                M477.867,384c0,14.114-11.486,25.6-25.6,25.6H332.783c0.239-0.324,0.418-0.708,0.657-1.041c0.503-0.708,0.939-1.451,1.399-2.193
                c0.887-1.434,1.698-2.91,2.415-4.454c0.393-0.836,0.759-1.664,1.092-2.526c0.64-1.647,1.152-3.345,1.587-5.077
                c0.196-0.802,0.444-1.579,0.597-2.398c0.486-2.569,0.802-5.197,0.802-7.91V196.267c0-23.526-19.14-42.667-42.667-42.667H230.4
                v-8.533c0-4.719-3.823-8.533-8.533-8.533h-85.333c-4.71,0-8.533,3.814-8.533,8.533v8.533h-25.6V51.2
                c0-14.114,11.486-25.6,25.6-25.6h102.4v93.867c0,3.311,1.92,6.323,4.915,7.723c3.004,1.408,6.545,0.956,9.079-1.161
                l45.739-38.118l45.739,38.118c0.717,0.597,1.527,1.024,2.372,1.348c0.273,0.111,0.555,0.154,0.836,0.23
                c0.589,0.162,1.178,0.282,1.783,0.316c0.162,0.009,0.307,0.077,0.469,0.077c0.136,0,0.273-0.085,0.41-0.094
                c1.092-0.051,2.185-0.239,3.208-0.717c2.995-1.399,4.915-4.412,4.915-7.723V25.6h102.4c14.114,0,25.6,11.486,25.6,25.6V384z"/>
              <path d="M298.667,375.467h-25.6c-4.71,0-8.533,3.814-8.533,8.533c0,4.719,3.823,8.533,8.533,8.533h25.6
                c4.71,0,8.533-3.814,8.533-8.533C307.2,379.281,303.377,375.467,298.667,375.467z"/>
              <path d="M298.667,341.333H256c-4.71,0-8.533,3.814-8.533,8.533S251.29,358.4,256,358.4h42.667c4.71,0,8.533-3.814,8.533-8.533
                S303.377,341.333,298.667,341.333z"/>
              `
            ]}
          });
        }
        if (production.indexOf('40') >= 0 || production.indexOf('41') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '原醋酸度設定',
            to: '/production/Acidity',
            icon: { content: [
              '50 50',
              `
              <path d="M48,42.00037v2.99981A3.00319,3.00319,0,0,1,45,48H5a3.00319,3.00319,0,0,1-3-2.99982V42.00037a.9994.9994,0,0,1,1-.99994H47A.9994.9994,0,0,1,48,42.00037Zm-3-2.99982V25.68985a3.80041,3.80041,0,0,1,1.26172-2.91193,4.97773,4.97773,0,0,0,1.68652-4.50363,5.10908,5.10908,0,0,0-5.10937-4.2722h-4.996a6.8393,6.8393,0,0,1,2.08483,3.9895,6.96469,6.96469,0,0,1-2.36425,6.3043A1.81217,1.81217,0,0,0,37,25.68985v13.3107Zm-10,0V25.68985a3.80041,3.80041,0,0,1,1.26172-2.91193,4.97773,4.97773,0,0,0,1.68652-4.50363,5.10908,5.10908,0,0,0-5.10937-4.2722h-4.996a6.8393,6.8393,0,0,1,2.08483,3.9895,6.96469,6.96469,0,0,1-2.36425,6.3043A1.81217,1.81217,0,0,0,27,25.68985v13.3107ZM2.05176,18.27429a5.10908,5.10908,0,0,1,5.10937-4.2722H22.83887a5.10908,5.10908,0,0,1,5.10937,4.2722,4.97773,4.97773,0,0,1-1.68652,4.50363A3.80041,3.80041,0,0,0,25,25.68985v13.3107H5V25.68985a3.80118,3.80118,0,0,0-1.26074-2.91144A4.97732,4.97732,0,0,1,2.05176,18.27429Zm8.24121,9.434a.99968.99968,0,0,0,1.41406,0l4-3.99976a.99986.99986,0,0,0-1.41406-1.414l-4,3.99975A.99953.99953,0,0,0,10.293,27.70828Zm0,6.99957a.99968.99968,0,0,0,1.41406,0l8-7.99951a.99986.99986,0,0,0-1.41406-1.414l-8,7.99951A.99953.99953,0,0,0,10.293,34.70785Zm15.61719-23.292a6.0768,6.0768,0,0,0-.13868-4.93622c-.4707-1.331-.667-2.00817.00875-2.85134a1.0002,1.0002,0,0,0-1.5605-1.25094c-1.40137,1.74891-.80957,3.42313-.334,4.76875a4.20064,4.20064,0,0,1,.20413,3.44265.99969.99969,0,1,0,1.82029.8271Zm-10,0a6.0768,6.0768,0,0,0-.13868-4.93622c-.4707-1.331-.667-2.00817.00875-2.85134a1.0002,1.0002,0,0,0-1.5605-1.25094c-1.40137,1.74891-.80957,3.42313-.334,4.76875a4.20064,4.20064,0,0,1,.20413,3.44265.99969.99969,0,1,0,1.82029.8271Zm20,0a6.0768,6.0768,0,0,0-.13868-4.93622c-.4707-1.331-.667-2.00817.00875-2.85134a1.0002,1.0002,0,0,0-1.5605-1.25094c-1.40137,1.74891-.80957,3.42313-.334,4.76875a4.20064,4.20064,0,0,1,.20413,3.44265.99969.99969,0,1,0,1.82029.8271Z"/>
              `
            ]}
          });
        }
        if (production.indexOf('50') >= 0 || production.indexOf('51') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '製令補退料',
            to: '/production/Refund',
            icon: { content: icons.cilCheckCircle },       
          });
        }     
      }

      var report = localStorage.getItem('report');
      if (report != null && report != "") {
        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['表單管理']
        });    
        if (report.indexOf('10') >= 0 || report.indexOf('11') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '調理日報表',
            to: '/report/deploy',
            icon: { content: icons.cilRestaurant } 
          });
        }
        if (report.indexOf('20') >= 0 || report.indexOf('21') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '生產日報表',
            to: '/report/package',
            icon: { content: icons.cibWebpack } 
          });
        }
        if (report.indexOf('30') >= 0 || report.indexOf('31') >= 0) {
          children.push( {
            _name: 'CSidebarNavItem',
            name: '製程檢驗報告單',
            to: '/report/madeTest',
            icon: { content: icons.cilClipboard } 
          });
        }
        if (report.indexOf('40') >= 0 || report.indexOf('41') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '包裝日報表',
            to: '/report/weight',
            icon: { content: [
              '320 320',
              `
                <path d="M265.27,0.003c-0.191-0.004-0.354-0.004-0.516-0.001L65.724,0.013c-0.487-0.016-0.951-0.018-1.494,0.002C28.805,0.428,0,29.565,0,65v200c0,35.841,29.159,65,65,65h200c35.841,0,65-29.159,65-65V65C330,29.289,300.992,0.166,265.27,0.003zM300,265c0,19.299-15.701,35-35,35H65c-19.299,0-35-15.701-35-35V65c0-19.092,15.533-34.788,34.552-34.987c0.146-0.001,0.292-0.004,0.447-0.008c0.156,0.004,0.325,0.007,0.531,0.008l199.363-0.011c0.061,0.001,0.126,0.001,0.181,0C284.332,30.042,300,45.742,300,65V265z"/><path d="M165,60c-43.123,0-81.377,25.856-97.456,65.87c-2.241,5.575-0.938,11.95,3.312,16.199l33.538,33.537C107.207,178.42,111.022,180,115,180h100c3.979,0,7.793-1.58,10.606-4.394l33.538-33.537c4.249-4.249,5.553-10.624,3.312-16.199C246.377,85.856,208.123,60,165,60z M208.787,150H180v-14.999c0-8.284-6.716-15-15-15s-15,6.716-15,15V150h-28.787l-21.669-21.669C112.69,104.77,137.455,90,165,90s52.311,14.77,65.456,38.331L208.787,150z"/>
              `
            ]}
          });
        }
        if (report.indexOf('50') >= 0 || report.indexOf('51') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '調理投料管制表',
            to: '/report/potcondition',
            icon: { content: icons.cilRestaurant } 
          });
        }
        if (report.indexOf('60') >= 0 || report.indexOf('61') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '濾網＆Ｏ型環報表單',
            to: '/report/bagOtype',
            icon: { content: icons.cilClipboard } 
          });
        }
        if (report.indexOf('70') >= 0 || report.indexOf('71') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '半成品檢驗單',
            to: '/report/semiFinished',
            icon: { content: icons.cilClipboard } 
          });
        }
        if (report.indexOf('80') >= 0 || report.indexOf('81') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '生產產能參數',
            to: '/report/parameter',
            icon: { content: icons.cilClipboard } 
          });
        }
      }

      var scm = localStorage.getItem('scm');
      if (scm != null && scm != "") {
        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['供應商管理']
        });    
        if (scm.indexOf('10') >= 0 || scm.indexOf('11') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '供應商管理',
            to: '/acceptance/scm',
            icon: { content:[
              '450 450',
              `
              <rect x="96" y="80" width="320" height="352" rx="32" ry="32"fill="none" stroke="currentColor" stroke-width="20"/><line x1="160" y1="160" x2="352" y2="160"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><line x1="160" y1="240" x2="352" y2="240"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><line x1="160" y1="320" x2="272" y2="320"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><circle cx="360" cy="340" r="40"fill="none" stroke="currentColor" stroke-width="20"/><path d="M320 400c40-30 80-30 120 0"fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round"/>
              `
            ]}
          });
        }
        if (scm.indexOf('20') >= 0 || scm.indexOf('21') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '供應商評鑑',
            to: '/acceptance/scmevaluation',
            icon: { content: [
              '512 512',
              `
              <rect x="96" y="80" width="320" height="352" rx="32" ry="32"fill="none" stroke="currentColor" stroke-width="20"/><line x1="160" y1="160" x2="352" y2="160"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><line x1="160" y1="240" x2="352" y2="240"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><line x1="160" y1="320" x2="272" y2="320"stroke="currentColor" stroke-width="20" stroke-linecap="round"/><path d="M360 280l20 40 44 6-32 32 8 45-40-22-40 22 8-45-32-32 44-6z"fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/>
              `
            ]}
          });
        }
        if (scm.indexOf('30') >= 0 || scm.indexOf('31') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '倉管檢驗',
            to: '/acceptance/warehouse',
            icon: { content: [
              '512 512',
              `
              <rect x="80" y="160" width="352" height="240" rx="20" ry="20"fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/><path d="M80 160 L256 80 L432 160"fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/><circle cx="350" cy="350" r="60"fill="none" stroke="currentColor" stroke-width="20"/><line x1="390" y1="390" x2="440" y2="440"stroke="currentColor" stroke-width="20" stroke-linecap="round"/>  <path d="M330 350 l20 20 40 -40"fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
              `
            ]}
          });
        }
        if (scm.indexOf('40') >= 0 || scm.indexOf('41') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '品保檢驗',
            to: '/acceptance/quality',
            icon: { content: [
              '512 512',
              `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32L96 96v128c0 141.4 84.5 227.2 160 256 75.5-28.8 160-114.6 160-256V96L256 32z"fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/><circle cx="220" cy="220" r="80" fill="none" stroke="currentColor" stroke-width="20"/><line x1="280" y1="280" x2="340" y2="340" stroke="currentColor" stroke-width="20" stroke-linecap="round"/><path d="M190 220l30 30 60-60" fill="none" stroke="currentColor" stroke-width="24" stroke-linecap="round" stroke-linejoin="round"/></svg>
              `
            ]}
          });
        }      
      }

      var system = localStorage.getItem('system');
      if (system != null && system != "") {
        children.push({
          _name: 'CSidebarNavTitle',
          _children: ['系統管理']
        });    
        if (system.indexOf('10') >= 0 || system.indexOf('11') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '訊息管理',
            to: '/system/message',
            icon: 'cil-bell'
          });
        }
        if (system.indexOf('20') >= 0 || system.indexOf('21') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '人員管理',
            to: '/system/users',
            icon: 'cil-people'
          });
        }
        if (system.indexOf('30') >= 0 || system.indexOf('31') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '權限管理',
            to: '/system/limit',
            icon: 'cil-chartPie'
          });
        }
        if (system.indexOf('40') >= 0 || system.indexOf('41') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '收料管理',
            to: '/system/receivematerial',
            icon: 'cil-laptop'
          });
        }      
        if (system.indexOf('50') >= 0 || system.indexOf('51') >= 0) {
          children.push({
            _name: 'CSidebarNavItem',
            name: '檢驗管理',
            to: '/system/checkitem',
            icon: 'cil-laptop'        
          });
        }   
      }

      var result = [];
      result.push({
        _name: 'CSidebarNav',
        _children: children
      })
      this.$options.nav = Vue.prototype.GLOBAL.sysType == 'SCM' ? scmjson : result;
    }

  },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}

const scmjson = [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: '主控版',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },    
      {
        _name: 'CSidebarNavItem',
        name: '採購資料',
        to: '/scm/purchase',
        icon: 'cil-chartPie'
      },   
      
      {
        _name: 'CSidebarNavItem',
        name: '倉管檢驗',
        to: '/scm/warehouse',
        icon: { content: [
  '512 512',
  `
  <!-- 箱子外框 -->
  <rect x="80" y="160" width="352" height="240" rx="20" ry="20"
        fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/>
  
  <!-- 箱子上蓋 -->
  <path d="M80 160 L256 80 L432 160"
        fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/>
  
  <!-- 放大鏡 -->
  <circle cx="350" cy="350" r="60"
        fill="none" stroke="currentColor" stroke-width="20"/>
  <line x1="390" y1="390" x2="440" y2="440"
        stroke="currentColor" stroke-width="20" stroke-linecap="round"/>
  
  <!-- 打勾 ✔ -->
  <path d="M330 350 l20 20 40 -40"
        fill="none" stroke="currentColor" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
  `
] }
      },    
      {
        _name: 'CSidebarNavItem',
        name: '品保檢驗',
        to: '/scm/quality',
        icon: { content: [
  '512 512',
  `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M256 32L96 96v128c0 141.4 84.5 227.2 160 256 75.5-28.8 160-114.6 160-256V96L256 32z"
      fill="none" stroke="currentColor" stroke-width="20" stroke-linejoin="round"/>
    <circle cx="220" cy="220" r="80" fill="none" stroke="currentColor" stroke-width="20"/>
    <line x1="280" y1="280" x2="340" y2="340" stroke="currentColor" stroke-width="20" stroke-linecap="round"/>
    <path d="M190 220l30 30 60-60" fill="none" stroke="currentColor" stroke-width="24" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  `
] }
      }    
    ]
  }
]


</script>
